// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__13Jj7","actionsCol":"EnrolledClinics_actionsCol__1vcLw"};